<form [formGroup]="form" *transloco="let t; read: 'credit-card'" class="w-full flex flex-col space-y-6">
  <div class="w-full flex flex-col space-y-1">
    <span class="font-medium">{{t('details')}}*</span>
    <div class="flex flex-auto items-center h-12 rounded-md w-full bg-card border border-gray-300 shadow-sm"
         [ngClass]="{'border-red-600': cardForm.touched && !cardForm.valid}" formGroupName="card">
      <div class="p-2 flex-grow">
        <input
                [required]="true"
                matInput
                type="tel"
                autocomplete="cc-number"
                ccNumber
                [placeholder]="t('number')"
                formControlName="number"
        />
      </div>
      <div class="flex flex-row items-center h-full">
        <div class="flex flex-auto justify-center w-20">
          <input
                  [required]="true"
                  class="text-center w-20"
                  matInput
                  type="tel"
                  autocomplete="cc-exp"
                  ccExp
                  [placeholder]="t('exp')"
                  [formControlName]="'exp'"
          />
        </div>
        <div class="h-full w-px bg-gray-300"></div>
        <div class="flex flex-auto justify-center w-20">
          <input
                  [required]="true"
                  class="w-20 text-center"
                  matInput
                  type="tel"
                  autocomplete="off"
                  ccCVC
                  [placeholder]="t('cvc')"
                  [formControlName]="'cvc'"
          />
        </div>
      </div>
    </div>
  </div>

  <mat-form-field class="fuse-mat-no-subscript w-full">
    <mat-label>{{t('holder')}}</mat-label>
    <input type="text" [required]="true" matInput formControlName="holder" [placeholder]="t('holderName')"/>
  </mat-form-field>

</form>
